import { get } from 'lodash-es';

const initialState = {};
export const UPDATE_HOUSE = 'HOUSE/UPDATE_HOUSE';

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_HOUSE:
      return {
        ...state,
        ...action.data
      };

    default:
      return state;
  }
};

export const updateHouse = data => dispatch => {
  dispatch({
    type: UPDATE_HOUSE,
    data
  });
};

export const updateHouseTransformer = ({ data }, houseConfig) => ({
  ...get(data, 'user.houseInfo', {}),
  houseAddresses: get(data, 'user.houseInfo.houseAddresses', []),
  autoChargeEnabled: get(houseConfig, 'autoChargeEnabled', false)
});
